import React from 'react'

import styles from './Search.module.scss'

const Icon: React.FC = () => {
  return (
    <svg
      className={styles.icon}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="14"
        cy="14"
        fill="none"
        id="XMLID_42_"
        r="9"
        stroke="#000000"
      ></circle>
      <line
        fill="none"
        id="XMLID_44_"
        stroke="#000000"
        x1="27"
        x2="20.366"
        y1="27"
        y2="20.366"
      ></line>
    </svg>
  )
}

export default Icon
